import { render } from "./AttachRemoveDivisionSitePlan.vue?vue&type=template&id=bf6d32c2"
import script from "./AttachRemoveDivisionSitePlan.vue?vue&type=script&lang=js"
export * from "./AttachRemoveDivisionSitePlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__